import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const postalCodesByBranchClient = async (branchID) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.postalCodebyBranch(branchID)}`;

    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    if (!res.ok) {
        return { error: true, message: 'Get Postal code request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default postalCodesByBranchClient;
